/* eslint no-param-reassign: "off" */

export default {
  install(Vue) {
    Vue.prototype.$geoIcons = {
      get(type) {
        switch (type) {
          case 'point_of_interest':
            return 'mdi-map-marker';
          case 'aquarium':
            return 'mdi-fish';
          case 'gym':
            return 'mdi-dumbbell';
          case 'stadium':
            return 'mdi-stadium-variant';
          case 'car_repair':
            return 'mdi-car-hatchback';
          case 'police':
            return 'mdi-car-emergency';
          case 'general_contractor':
          case 'real_estate_agency':
            return 'mdi-office-building';
          case 'local_government_office':
            return 'mdi-map-marker';
          case 'health':
            return 'mdi-hospital';
          case 'accounting':
          case 'finance':
            return 'mdi-cash-multiple';
          case 'liquor_store':
            return 'mdi-bottle-wine';
          case 'bakery':
            return 'mdi-baguette';
          case 'bar':
            return 'mdi-glass-mug-variant';
          case 'cafe':
            return 'mdi-coffee';
          case 'lodging':
            return 'mdi-bed';
          case 'night_club':
            return 'mdi-glass-cocktail';
          case 'transit_station':
          case 'subway_station':
          case 'train_station':
          case 'light_rail_station':
            return 'mdi-train';
          case 'bus_station':
            return 'mdi-bus';
          case 'supermarket':
          case 'grocery_or_supermarket':
          case 'shopping_mall':
            return 'mdi-cart';
          case 'cemetery':
            return 'mdi-grave-stone';
          case 'food':
          case 'restaurant':
            return 'mdi-silverware-fork-knife';
          case 'premise':
          case 'subpremise':
          case 'street_address':
            return 'mdi-home';
          case 'route':
            return 'mdi-road-variant';
          case 'airport':
            return 'mdi-airplane';
          case 'church':
            return 'mdi-church';
          case 'secondary_school':
          case 'school':
          case 'university':
            return 'mdi-school';
          case 'art_gallery':
          case 'museum':
          case 'tourist_attraction':
            return 'mdi-bank';
          case 'amusement_park':
            return 'mdi-ferris-wheel';
          case 'park':
            return 'mdi-pine-tree'
          case 'spa':
            return 'mdi-spa';
          case 'pet_store':
            return 'mdi-cat';
          case 'zoo':
            return 'mdi-bird';
          case 'synagogue':
            return 'star-david';
          case 'mosque':
            return 'star-crescent';
          case 'place_of_worship':
            return 'dharmachakra';
          case 'embassy':
            return 'mdi-flag'
          case 'book_store':
          case 'library':
            return 'mdi-book-open-variant'
          case 'natural_feature':
            return 'mdi-nature'
          case 'country':
            return 'earth';
          case 'administrative_area_level_1':
          case 'administrative_area_level_2':
          case 'administrative_area_level_3':
          case 'administrative_area_level_4':
          case 'administrative_area_level_5':
          case 'sublocality_level_1':
          case 'sublocality_level_2':
          case 'sublocality_level_3':
          case 'sublocality_level_4':
          case 'sublocality_level_5':
          case 'neighborhood':
          case 'locality':
            return 'mdi-map-marker-radius';
          default:
            console.log(type);
            return 'mdi-map-marker-radius';
        }
      }
    };
  }
};
